import { useNavigate } from "react-router-dom";
import { ArrowRight, Check, CalendarCheck2, MessageCircle, Megaphone, Users } from "lucide-react";

const CHECKOUT_URL = process.env.REACT_APP_DOWNSELL_CHECKOUT_URL || "";

export default function Downsell() {
  const nav = useNavigate();
  const accept = () => {
    if (CHECKOUT_URL) window.location.href = CHECKOUT_URL;
    else nav("/obrigado");
  };

  return (
    <div className="min-h-screen bg-[#FFFDFC] text-[#27272A]">
      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#F5ECE8] text-[#682F3E] px-3 py-1.5 text-xs font-extrabold uppercase tracking-wider">
            Uma opção mais enxuta
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold leading-[1.04] mt-5">
            Você não precisa levar o método completo agora.
          </h1>
          <p className="text-lg md:text-xl text-[#6F696D] mt-5 leading-relaxed">
            Comece com o <b>Plano Agenda Cheia — 7 Dias</b>: uma versão enxuta do Nail Designer 360 para colocar sua agenda em movimento com uma ação prática por dia.
          </p>
        </div>

        <div className="mt-10 rounded-[34px] bg-white border border-[#E8DDD8] shadow-[0_24px_70px_rgba(104,47,62,.10)] overflow-hidden">
          <div className="bg-[#682F3E] text-white p-7 md:p-9">
            <div className="text-sm text-[#EBD8D2] font-bold uppercase tracking-wider">Plano Agenda Cheia — 7 Dias</div>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold mt-2">Uma semana. Sete ações. Sem complicação.</h2>
          </div>

          <div className="p-7 md:p-9 grid md:grid-cols-2 gap-7">
            <div className="space-y-4">
              {[
                [CalendarCheck2, "Roteiro diário com 7 ações práticas"],
                [Users, "Mensagens para reativar clientes antigas"],
                [Megaphone, "Campanha para divulgar horários vagos"],
                [MessageCircle, "Roteiro de stories e chamada para agendamento"],
              ].map(([Icon, text]) => (
                <div key={text} className="flex gap-3 items-start">
                  <div className="w-10 h-10 rounded-xl bg-[#F5ECE8] flex items-center justify-center text-[#682F3E] shrink-0"><Icon size={19} /></div>
                  <div className="font-semibold pt-2">{text}</div>
                </div>
              ))}
            </div>

            <div className="rounded-3xl bg-[#FAF5F2] p-6 text-center">
              <div className="text-sm text-[#71717A]">Leve somente o plano por</div>
              <div className="font-display text-5xl font-extrabold text-[#682F3E] mt-2">R$ 19,90</div>
              <div className="text-xs text-[#71717A] mt-2">pagamento único</div>
              <button onClick={accept}
                className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-[#682F3E] text-white font-extrabold px-5 py-4 hover:bg-[#542431] transition">
                QUERO O PLANO DE 7 DIAS <ArrowRight size={18} />
              </button>
              <button onClick={() => nav("/obrigado")}
                className="mt-4 text-sm text-[#817A7D] underline underline-offset-4">
                Não, seguir apenas com minha compra
              </button>
            </div>
          </div>
        </div>

        <div className="mt-7 text-center text-sm text-[#6F696D] flex items-center justify-center gap-2">
          <Check size={16} className="text-[#4F7A61]" /> Seu acesso ao NailControl continua garantido mesmo se você não adicionar esta oferta.
        </div>
      </main>
    </div>
  );
}
